import type { ReactNode } from 'react';

export enum HEADER_CONST {
  TEST_ID = 'header',
}

export type HeaderProps = {
  children?: ReactNode;
  /**
   * Fixed on top of the page.
   */
  fixed?: boolean;
  justify?: 'space-between' | 'center';
  topbar?: ReactNode;
};
